import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import knightsOneTrainersData from '../data/KnightsOne';
import './KnightsOne.css';

const KnightsOneTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(knightsOneTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('⚔️ Knights One trainer selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/knight-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/knights-train-categories');
    };

    return (
        <div className="knights-trainers-container">
            <div className="knights-animated-background"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="knights-trainers-header">
                <div className="header-content">
                    <h1>Legendary Knights of the Round Table</h1>
                    <p>Train with the greatest champions of Camelot and beyond</p>
                    <div className="category-stats">
                        <span className="stat-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge">Category: Medieval Knights</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="knights-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="knight-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                        style={{
                            '--knight-primary-color': trainer.color,
                            '--knight-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Trainer Image */}
                        <div className="knight-trainer-image-section">
                            <div
                                className="knight-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="steel-gleam-effect"></div>
                                <div className="experience-badge knight-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="knight-trainer-info-section">
                            <h3 className="knight-trainer-name">{trainer.name}</h3>
                            <h4 className="knight-trainer-title">{trainer.title}</h4>
                            <p className="knight-trainer-specialization">{trainer.specialization}</p>
                            <p className="knight-trainer-description">{trainer.intro}</p>

                            <div className="knight-trainer-details">
                                <div className="detail-item knight-detail">
                                    <div className="detail-icon">⚔️</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item knight-detail">
                                    <div className="detail-icon">🛡️</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="knights-trainers-footer">
                <div className="knights-info">
                    <h3>Knights of the Round Table Philosophy</h3>
                    <div className="knights-benefits-grid">
                        <div className="knight-benefit-item">
                            <div className="benefit-icon">🏆</div>
                            <div>
                                <strong>Tournament Mastery</strong>
                                <p>Elite combat conditioning for championship-level performance</p>
                            </div>
                        </div>
                        <div className="knight-benefit-item">
                            <div className="benefit-icon">⚔️</div>
                            <div>
                                <strong>Sword Excellence</strong>
                                <p>Perfect technique through legendary weapon mastery</p>
                            </div>
                        </div>
                        <div className="knight-benefit-item">
                            <div className="benefit-icon">🌞</div>
                            <div>
                                <strong>Solar Strength</strong>
                                <p>Natural power cycles that maximize physical potential</p>
                            </div>
                        </div>
                        <div className="knight-benefit-item">
                            <div className="benefit-icon">🏺</div>
                            <div>
                                <strong>Grail Quest Training</strong>
                                <p>Sacred conditioning that achieves the impossible</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KnightsOneTrainers;